import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import classes from "./AddSupervisorModal.module.css";
import TextField from "@mui/material/TextField";
import AsttButton from "components/AsttButton/AsttButton";
import AsttButtonLight from "components/ASTTButtonLight/AsttButtonLight";
import { getSupervisorDetails } from "services/centerPointUserServices";
import { addNonHRMSEmployeeActions } from "Store/addNonHRMSEmployee";
import { useDispatch } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import PropTypes from "prop-types";

export default function AddSupervisorModal(props) {
  const { handleClose } = props;
  const dispatch = useDispatch();
  const [error, setError] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [noData, setNoData] = React.useState(false);
  const [name, setName] = React.useState("");
  const [loader, setLoader] = React.useState("");
  const [supervisorDetailsArray, setSuperVisorDetailsArray] = React.useState(
    []
  );

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  async function fetchData() {
    setLoader(true);
    try {
      if (name.length >= 3) {
        setError(false);
        const response = await getSupervisorDetails(name);
        if (response?.data?.message === "Success") {
          setSuperVisorDetailsArray(response?.data?.data);
          setNoData(false);
        } else {
          setNoData(true);
        }
      } else {
        setError(true);
        setSuperVisorDetailsArray([]);
      }
    } catch (error) {}

    setLoader(false);
  }

  function onSupervisorClick(item) {
    dispatch(addNonHRMSEmployeeActions.updateSupervisor(item));
    setName("");
    setSuperVisorDetailsArray([]);
    handleClose();
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={classes.modalContainer}>
        <div className={classes.container}>
          <div className={classes.header}>
            <CloseIcon
              className={classes.close}
              onClick={() => {
                handleClose();
                setName("");
                setSuperVisorDetailsArray([]);
              }}
            />
          </div>
          <div className={classes.inputContainer}>
            <TextField
              id="outlined-basic"
              variant="outlined"
              label="First name/Last Name/ Oracle Id"
              value={name}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  fetchData();
                }
              }}
              onChange={(e) => {
                if (e.target.value.length >= 3) setError(false);
                setName(() => e.target.value);
              }}
              className={classes.searchField}
              multiline
              rows={1}
              sx={{
                "& .MuiInputBase-input": {
                  padding: "10px",
                },
              }}
            />

            <AsttButton buttonClass={classes.find} onClick={fetchData}>
              Find
            </AsttButton>
            <AsttButtonLight
              className={classes.find}
              onClick={() => {
                setSuperVisorDetailsArray([]);
                setName("");
                setError(false);
              }}
            >
              Clear
            </AsttButtonLight>
          </div>
          {error && (
            <p className={classes.error}>
              Please enter atleast 3 characters to search !
            </p>
          )}
          <div
            className={loader ? classes.loaderContainer : classes.listContainer}
          >
            {loader ? (
              <CircularProgress sx={{ color: "#A8A8A8" }} />
            ) : (
              <>
                {noData ? (
                  <p className={classes.noData}>No Data found!</p>
                ) : (
                  supervisorDetailsArray.map((supervisor, index) => (
                    <button
                      className={classes.supervisors}
                      key={index + supervisor.OracleId}
                      onClick={(e) => onSupervisorClick(supervisor)}
                    >
                      {supervisor.FirstName} &nbsp;
                      {supervisor.LastName} &nbsp; - &nbsp;
                      {supervisor.OracleId}
                    </button>
                  ))
                )}
              </>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
}

AddSupervisorModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
